import { Button, type ButtonProps } from '@/components/ui/button'
import { cn } from 'src/utilities/cn'
import Link from 'next/link'
import React from 'react'

import type { Page } from '@/payload-types'
import { ChevronRight } from 'lucide-react'
import { getLinkUrl } from '@/fields/link'

export type CMSLinkType = {
  appearance?: 'inline' | ButtonProps['variant']
  children?: React.ReactNode
  className?: string | null
  label?: string | null
  action?: boolean | null
  newTab?: boolean | null
  reference?: {
    relationTo: 'pages'
    value: Page | string | number
  } | null
  size?: ButtonProps['size'] | null
  type?: 'custom' | 'reference' | null
  url?: string | null
}

export const CMSLink: React.FC<CMSLinkType> = (props) => {
  const {
    type,
    appearance = 'inline',
    children,
    className,
    label,
    newTab,
    reference,
    size: sizeFromProps,
    url,
  } = props

  const href = getLinkUrl(props)

  if (!href) return null

  const size = appearance === 'link' ? 'clear' : sizeFromProps
  const newTabProps = newTab ? { rel: 'noopener noreferrer', target: '_blank' } : {}

  /* Ensure we don't break any styles set by richText */
  if (appearance === 'inline') {
    return (
      <Link className={cn(className)} href={href || url || ''} {...newTabProps}>
        {label && label}
        {children && children}
      </Link>
    )
  }

  return (
    <Button className={cn(className, 'group')} size={size} variant={appearance}>
      {props.action ? (
        <div className={'transition-all duration-100 ease-in-out pr-2 group-hover:pr-0'}>
          <ChevronRight />
        </div>
      ) : (
        ''
      )}
      <Link href={href || url || ''} {...newTabProps}>
        {children ?? label}
      </Link>
    </Button>
  )
}
